"use client";

import React from "react";
import { MapPin, CircleCheck } from "lucide-react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const servedTowns = [{
  id: 1,
  name: "Gloucester"
}, {
  id: 2,
  name: "Cheltenham"
}, {
  id: 3,
  name: "Stroud"
}, {
  id: 4,
  name: "Tewkesbury"
}, {
  id: 5,
  name: "Cirencester"
}, {
  id: 6,
  name: "Dursley"
}, {
  id: 7,
  name: "Innsworth"
}, {
  id: 8,
  name: "Churchdown"
}, {
  id: 9,
  name: "Quedgeley"
}, {
  id: 10,
  name: "Brockworth"
}];
const mapHubs = [{
  id: 1,
  top: "65%",
  left: "65%",
  label: "Success Story: Gloucester"
}, {
  id: 2,
  top: "50%",
  left: "55%",
  label: "Success Story: Cheltenham"
}, {
  id: 3,
  top: "35%",
  left: "48%",
  label: "Success Story: Stroud"
}, {
  id: 4,
  top: "75%",
  left: "40%",
  label: "Success Story: Dursley"
}, {
  id: 5,
  top: "20%",
  left: "45%",
  label: "Success Story: Tewkesbury"
}];
export default function OurServiceArea() {
  const {
    ref: cardRef,
    isVisible: isCardVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="169923" id="the-local-advantage" className="relative w-full bg-[#1A1A1A] min-h-[600px] lg:min-h-[700px] flex items-center overflow-hidden py-12 lg:py-0">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1615185/img/grayscale_uk_map_bg.png)] bg-cover bg-center opacity-20 grayscale mix-blend-overlay" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#1A1A1A]/95 via-[#1A1A1A]/60 to-transparent lg:w-2/3" />
      </div>

      {}
      <div className="absolute inset-0 z-0 hidden md:block">
        <div className="relative w-full max-w-5xl mx-auto h-full">
          {mapHubs.map((hub, i) => <div key={hub.id} data-index={i} className="absolute flex flex-col items-center group cursor-pointer" style={{
          top: hub.top,
          left: hub.left
        }}>
              <div className="relative">
                <MapPin className="text-[#FF8C00] size-8 drop-shadow-[0_0_8px_rgba(255,140,0,0.5)] relative z-10 transition-transform duration-300 group-hover:-translate-y-1 group-hover:scale-110" />
                <div className="absolute inset-0 bg-[#FF8C00]/30 rounded-full blur-md scale-150 animate-pulse z-0" />
              </div>
              <span className="mt-2 px-3 py-1 bg-[#FF8C00] text-white text-xs font-serif font-black uppercase tracking-wider rounded-sm opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap shadow-lg">
                {hub.label}
              </span>
            </div>)}
        </div>
      </div>

      {}
      <div className="container relative z-10 mx-auto px-4 md:px-6">
        <div ref={cardRef} className={`max-w-md w-full transition-all duration-700 ease-out ${isCardVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-12"}`}>
          <Card className="bg-[#1A1A1A]/95 backdrop-blur-md border-white/10 shadow-2xl overflow-hidden">
            <div className="absolute top-0 left-0 w-full h-1 bg-[#FF8C00]" />
            <CardHeader className="pb-4">
              <CardTitle className="text-4xl font-serif font-black uppercase tracking-tighter text-white">
                The Local Advantage
              </CardTitle>
              <CardDescription className="text-lg font-sans text-gray-400 mt-3 leading-relaxed">We don't just do Apps to make your life eaiser; we dominate local SEO in your backyard. Helping Gloucester firms own the map and capture every lead.</CardDescription>
            </CardHeader>
            <CardContent>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-3">
                {servedTowns.map((town, i) => <div key={town.id} data-index={i} className="flex items-center gap-2.5 group">
                    <CircleCheck className="size-5 text-[#FF8C00] shrink-0 transition-transform group-hover:scale-110" />
                    <span className="text-white font-sans font-bold text-sm group-hover:text-[#FF8C00] transition-colors">
                      {town.name}
                    </span>
                  </div>)}
              </div>
              
              <div className="mt-8 pt-6 border-t border-white/10">
                <p className="text-xl font-serif font-black text-[#FF8C00] uppercase tracking-wider mb-4 cursor-pointer hover:underline">Dominate My Area: Join us today.</p>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>;
}